import { render, staticRenderFns } from "./AppContactObjectTypeList.vue?vue&type=template&id=1ae1072c&scoped=true&"
import script from "./AppContactObjectTypeList.vue?vue&type=script&lang=js&"
export * from "./AppContactObjectTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1072c",
  null
  
)

export default component.exports